<template>
  <v-container fluid>
    <!-- Global Tarih Filtresi -->
    <v-card class="mb-4" outlined>
      <v-card-title>
        <v-icon left>mdi-view-dashboard</v-icon>
        Tüm Formlar
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu v-model="startMenu" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.startDate"
                  label="Başlangıç Tarihi"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"      
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="filters.startDate" @input="startMenu = false" locale="tr-TR" />
            </v-menu>
          </v-col>
            <v-col cols="12" md="4">
                <v-combobox v-model="selectedBirim" :items="birims" :return-object="true" item-text="ad" clearable
              item-value="id" value="id" label="Birim"></v-combobox>
            </v-col>

          <!-- <v-col cols="12" md="4">
            <v-menu v-model="endMenu" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.endDate"
                  label="Bitiş Tarihi"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="filters.endDate" @input="endMenu = false" />
            </v-menu>
          </v-col> -->

          <v-col cols="12" md="4" class="d-flex align-end">
            <v-btn color="primary" block @click="loadDashboard">
              <v-icon left>mdi-refresh</v-icon>
              Yenile
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
<v-text-field

  label="Filtreleme"
 v-model="searchText"
></v-text-field>
    <!-- Genel Özet -->
    <v-row>
      <v-col cols="12" md="3" v-for="item in summary" :key="item.title">
        <v-card outlined>
          <v-card-text class="text-center">
            <v-icon size="36" color="primary">{{ item.icon }}</v-icon>
            <div class="text-h5 mt-2">{{ item.value }}</div>
            <div class="caption grey--text">{{ item.title }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Form Kartları -->
    <v-row class="mt-4">
      <v-col
        cols="12"
        md="4"
        v-for="form in filteredForms"
        :key="form.id"
      >
        <v-card outlined class="h-100 d-flex flex-column">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>
              <v-icon left color="primary">mdi-file-document</v-icon>
              {{ form.formName }}
            </div>
            <div class="days-left" :class="daysLeftColor(form)">
              {{ daysLeft(form) }}
              <div class="days-left-label">gün kaldı</div>
            </div>
          </v-card-title>

          <v-card-subtitle>
            <div>
               Oluşturan: <strong>{{ form.createdBy }}</strong>
            </div>
           <div>
               Birim: <strong>{{ form.formBirim }}</strong>
           </div>
           
          </v-card-subtitle>

          <v-divider />

          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon small>mdi-calendar-start</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Başlangıç: {{ form.startDate | dateF}}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon small>mdi-calendar-end</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Bitiş: {{ form.endDate | dateF}}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon small>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Başvuran Sayısı: <strong>{{ form.applicationCount }}</strong>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-divider />

          <v-card-actions class="mt-auto">
      
            <v-btn text color="primary" @click="goToFormDetail(form.id)">
              Başvurular
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
                  <v-spacer />
                        <v-btn text color="primary" @click="goToChart(form.id)">
              Anket Raporu
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
            
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormService from '@/services/FormService';
import BirimService from '@/services/BirimService';
import Vue from 'vue';
export default {
  name: 'FormsDashboard',
filters: {
  dateF: function (value) {
    
    if (!value) return ''

const date = new Date(value);

return date.toLocaleString("tr-TR"); 
// "1.1.2026"
  }

},
  data () {
    return {
      birims:[],
      selectedBirim: null,
      selectedBirimId: null,
      searchText:"",
      startMenu: false,
      endMenu: false,
today:new Date(),
      filters: {
        startDate: null,
        endDate: null
      },

      summary: [
        { title: 'Toplam Form', value: 0, icon: 'mdi-file-multiple' },
        { title: 'Toplam Başvuru', value: 0, icon: 'mdi-counter' },
        { title: 'Aktif Form', value: 0, icon: 'mdi-play-circle' },
        { title: 'Pasif Form', value: 0, icon: 'mdi-stop-circle' }
      ],

      forms: []
    }
  },
  watch: {
  selectedBirim(newVal) {
    if (newVal) {
      this.selectedBirimId = newVal.id;     // backend için id
     // this.editedItem.birimName = newVal.name; // UI veya log için name
    } else {
      this.selectedBirimId = null;
      //this.editedItem.birimName = '';
    }
  }
},
  methods: {
    loadDashboard () {
      // TODO: API -> /api/dashboard/forms
BirimService.listBirims().then((result) => {
        this.birims = result.data;
        console.log("Birims:", this.birims);
      }).catch((err) => {

      });
      FormService.AnketDashboardReport(this.filters.startDate,this.selectedBirimId).then((result) => {
this.summary=result.data.headers;
this.forms=result.data.cards;
this.filters.startDate=result.data.date;
this.today=new Date(result.data.today);

console.log("AnketDashboardReport:",result.data );

      }).catch((err) => {});




    //   this.forms = [
    //     {
    //       id: 1,
    //       formName: 'İzin Talep Formu',
    //       createdBy: 'İK Birimi',
    //       startDate: '2025-01-01',
    //       endDate: '2025-01-31',
    //       applicationCount: 42,
    //       active: true
    //     },
    //     {
    //       id: 2,
    //       formName: 'Harcama Bildirim Formu',
    //       createdBy: 'Mali İşler',
    //       startDate: '2025-01-05',
    //       endDate: '2025-02-15',
    //       applicationCount: 18,
    //       active: false
    //     }
    //   ]

    //   this.summary[0].value = this.forms.length
    //   this.summary[1].value = this.forms.reduce((t, f) => t + f.applicationCount, 0)
    //   this.summary[2].value = this.forms.filter(f => f.active).length
    //   this.summary[3].value = this.forms.filter(f => !f.active).length
    },

    daysLeft (form) {
      const end = new Date(form.endDate)
      const today = this.today;
      const diff = Math.ceil((end - today) / (1000 * 60 * 60 * 24))
      console.log("object",diff);
      return diff > 0 ? diff : 0
    },

    daysLeftColor (form) {
      const d = this.daysLeft(form)
      if (d <= 3) return 'danger'
      if (d <= 7) return 'warning'
      return 'success'
    },

    goToFormDetail (formId) {
      this.$router.push({ name: 'formdata', params: { id: formId } })
    },
        goToChart (formId) {
      this.$router.push({ name: 'anketRapor', params: { id: formId } })
      
    }

  },
  computed: {
    filteredForms() {
      return this.forms.filter(form =>
        form.formName.toLocaleLowerCase("tr-TR").includes(this.searchText.toLocaleLowerCase("tr-TR"))
      );
    }
  }
,
  mounted () {
    this.loadDashboard()
  }
}
</script>

<style scoped>
.h-100 {
  height: 100%;
}

.days-left {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
}

.days-left-label {
  font-size: 12px;
  font-weight: 400;
}

.success {
  color: #2e7d32;
}

.warning {
  color: #f9a825;
}

.danger {
  color: #c62828;
}
</style>
